import { createSelector } from 'reselect'
import { IUsersState } from 'types/user'

interface IStore {
  users: IUsersState
}

export const selectUsers = (state: IStore) => state.users

export const selectUsersList = createSelector(selectUsers, ({ list }) => list)

export const selectUsersCount = createSelector(selectUsers, ({ totalCount }) => totalCount)

export interface IUserOption {
  id: string
  text: string
  carrierApplicationId?: string
  label?: string
  value?: string
}

export const selectUsersAutoComplete = createSelector(selectUsers, ({ list }) =>
  list.map(
    ({ firstName, id, lastName }): IUserOption => ({
      id: id.toString(),
      text: `${firstName} ${lastName}` || '',
    })
  )
)
